import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";
import { toFormatSearchs } from "~pages/PriceSearchV2/utils/searchHelpers";

const useGetFilterLookup = ({ loadingMapaData, totalItems, clienteId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFilterLookup = async () => {
      setLoading(true);

      try {
        const produtos = [];
        await db.pesquisaProdutos.each((produto) => {
          produtos.push(produto);
        });

        const gruposMateriais = [];
        await db.pesquisaGrupoMaterial.each((grupo) => {
          gruposMateriais.push(grupo);
        });

        const pesquisaObjs = {
          pesquisaProdutos: produtos
            ? { pesquisaProdutoObjeto: getColumnIntoKey({ data: produtos, prefix: "id-" }) }
            : {},
          pesquisaGrupoMateriais: gruposMateriais
            ? { pesquisaGrupoMaterialObjeto: getColumnIntoKey({ data: gruposMateriais, prefix: "id-" }) }
            : {},
          pesquisaCanaisDistribuicao: null,
          pesquisaEmbalagens: null,
          pesquisaMedidas: null,
          pesquisaPlayers: null,
          pesquisaPrazos: null,
          pesquisaCentros: null,
          pesquisaMotivosCompra: null,
        };

        let all_searchs = [];
        await db.mapaDaMina
          .where("clienteId")
          .equals(Number.parseInt(clienteId))
          .each((e) => {
            if (e.deletedAt === undefined && !e.clienteFechado && !e.clienteNaoConsomeBasicos && e.pesquisaProdutoId) {
              all_searchs.push(e);
            }
          });

        all_searchs = toFormatSearchs({ searchs: all_searchs, pesquisaObjetos: pesquisaObjs });

        let temp = {};
        for (const e of all_searchs) {
          const dados = e.dadosGerais;
          if (dados?.produto?.id) {
            const index_search = `pesquisa-${dados?.produto?.id}`;
            if (!temp[index_search]) {
              temp[index_search] = {
                produto: dados.produto?.nome,
                grupoProduto: dados.grupoProduto?.nome,
              };

              temp[index_search].produto = {
                descricaoProduto: dados.produto?.nome,
                id: dados.produtoId,
                codigo: dados.produto?.codigo,
                grupoProdutoId: dados.grupoProdutoId,
              };

              temp[index_search].grupoProduto = {
                nome: dados.grupoProduto?.nome,
                id: dados.grupoProdutoId,
                codigo: dados.grupoProduto?.codigo,
              };
            }
          }
        }

        setData(Object.values(temp));
      } catch (error) {
        console.error("Erro ao buscar filtros:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFilterLookup();
  }, [loadingMapaData, totalItems, clienteId]);

  return {
    data,
    loading,
  };
};

export default useGetFilterLookup;
